import React from 'react';
import ComparisonContainer from './ComparisonContainer/ComparisonContainer';
import PrivatePageHOC from '../../containers/PrivatPageHOC/PrivatePageHOC';

const SoterTaskComparison = () => <ComparisonContainer />;

export default PrivatePageHOC(SoterTaskComparison);
